module.exports = __webpack_public_path__ + "static/media/customer-success-leitner-ropeways-feature.296939bc.jpg";